<template>
  <div class="appt-confirm">
    <div class="appt-cap1 t-bold">{{ title }}</div>
    <div class="w-100 mt-2" v-if="criticalError">
      <p class="text-center text-red text-italic">
        <strong
          >Something went wrong. Please try to submit the form again.</strong
        >
      </p>
    </div>
    <div class="appt-confirm-stages">
      <FormStoreReview @goToEdit="gotoEdit(0)" :number="1"></FormStoreReview>
      <FormServiceReview
        @goToEdit="gotoEdit(1)"
        :number="2"
      ></FormServiceReview>
      <FormDateTime @goToEdit="gotoEdit(2)" :number="3"></FormDateTime>
      <FormContactReview
        @goToEdit="gotoEdit(3)"
        :number="4"
      ></FormContactReview>
    </div>
    <div class="goto-next">
      <div class="btn-back c-pointer" @click="back">Back</div>
      <div
        class="btn-next btn-book c-pointer active"
        @click="process_form"
        v-if="!formProcessing"
        :disabled="!formComplete"
      >
        Book Now
      </div>
      <div class="btn-next btn-book c-pointer active" v-if="formProcessing">
        Processing
      </div>
    </div>
  </div>
</template>

<script>
import FormStoreReview from "./../partials/FormStoreReview";
import FormServiceReview from "./../partials/FormServiceReview";
import FormDateTime from "./../partials/FormDateTime";
import FormContactReview from "./../partials/FormContactReview";
export default {
  props: {
    title: String,
    formType: String,
  },
  components: {
    FormStoreReview,
    FormServiceReview,
    FormDateTime,
    FormContactReview,
  },
  created() {
    this.setUserPageURL();
  },
  mounted() {
    if (this.$store.getters.validAppointmentState && !this.formComplete) {
      this.$emit("goToEdit", this.$store.getters.validAppointmentState);
    }
  },
  computed: {
    formComplete() {
      return this.$store.getters.appointmentFormComplete;
    },
    formProcessing() {
      return this.$store.state.form_processing;
    },
    criticalError() {
      return this.$store.state.critical_form_error;
    },
  },
  methods: {
    setUserPageURL() {
      this.$store.commit("setUserCurrentPage");
    },
    gotoEdit: function (index) {
      this.$emit("goToEdit", index);
    },
    back: function () {
      this.$emit("back");
    },
    process_form() {
      this.$store.dispatch("submitLead", this.formType);
    },
  },
};
</script>
<style>
.text-red {
  color: red;
}
</style>
